import { render } from "./page-budaya.vue?vue&type=template&id=082c7b3e&scoped=true"
import script from "./page-budaya.vue?vue&type=script&lang=js"
export * from "./page-budaya.vue?vue&type=script&lang=js"

import "./page-budaya.vue?vue&type=style&index=0&id=082c7b3e&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082c7b3e"]])

export default __exports__